﻿    <h1 mat-dialog-title>{{ 'UPLOAD_DIALOG.TITLE' | translate }}</h1>
    <div mat-dialog-content>
        <div class="review-text">{{ 'UPLOAD_DIALOG.ASSESSMENT' | translate }} {{ getReviewPeriodName() }}</div>

        <div *ngIf="appState.company.value">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'UPLOAD_DIALOG.TYPE' | translate }}</mat-label>
                <mat-select [(value)]="docType" (selectionChange)="docTypeChanged($event.value)">
                    <mat-option *ngFor="let endpoint of endpointList" [value]="endpoint.id">{{ endpoint.nameKey | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
    
            <div class="options">
                <mat-checkbox *ngIf="docType && docType != 1 && docType != 4" class="multiline with-icon" [(ngModel)]="assignToReviewPeriod">{{ 'UPLOAD_DIALOG.ASSIGN_TO_ASSESSMENT' | translate }}
                    <mat-icon class="info" matTooltip="{{ 'UPLOAD_DIALOG.ASSIGN_TO_ASSESSMENT_TOOLTIP' | translate }}">info</mat-icon></mat-checkbox>
                <mat-checkbox *ngIf="docType && docType == 3" class="multiline with-icon" [(ngModel)]="isOverwriteAllowed">{{ 'UPLOAD_DIALOG.OVERWRITE' | translate }}
                    <mat-icon class="info" matTooltip="{{ 'UPLOAD_DIALOG.OVERWRITE_TOOLTIP' | translate }}">info</mat-icon>
                </mat-checkbox>

                <ng-container *ngIf="docType == 1">
                    <div class="margin-top-sm">{{ 'UPLOAD_DIALOG.SAMPLE' | translate }} <a href="/assets/quantille-skalak-import.xlsx" title="minta import file">{{ 'UPLOAD_DIALOG.SCALES_IMPORT_FILE' | translate }}</a> letöltése.</div>
                </ng-container>
                <ng-container *ngIf="docType == 2">
                    <!-- <mat-checkbox class="multiline" [(ngModel)]="updateInReviewPeriod">Frissítés a kiválasztott értékelésben (!)</mat-checkbox> -->
                    <div class="margin-top-sm">{{ 'UPLOAD_DIALOG.SAMPLE' | translate }} <a href="/assets/quantille-kompetenciak-import.xlsx" title="minta import file">{{ 'UPLOAD_DIALOG.QUESTIONS_IMPORT_FILE' | translate }}</a> letöltése.</div>
                </ng-container>
                <ng-container *ngIf="docType == 3">
                    <div class="margin-top-sm">{{ 'UPLOAD_DIALOG.SAMPLE' | translate }} <a href="/assets/quantille-alkalmazott-import.xlsx" title="minta import file">{{ 'UPLOAD_DIALOG.EMPLOYEES_IMPORT_FILE' | translate }}</a> letöltése.</div>
                </ng-container>
                <ng-container *ngIf="docType == 4">
                    <div class="margin-top-sm">{{ 'UPLOAD_DIALOG.SAMPLE' | translate }} <a href="/assets/quantille-celkituzes-import.xlsx" title="minta import file">{{ 'UPLOAD_DIALOG.GOALS_IMPORT_FILE' | translate }}</a> letöltése.</div>
                </ng-container>
            </div>
        
            <angular-file-uploader #fileUpload class="uploader"
                [config]="afuConfig"
                (beforeUpload)="beforeUpload($event)"
                (ApiResponse)="handleResult($event)">
            </angular-file-uploader>
            
        </div>
    
  
    </div>
    <div mat-dialog-actions class="flex-h flex-end">
        <mat-progress-spinner *ngIf="inProgress"
            diameter="28"
            color="primary"
            mode="indeterminate">
        </mat-progress-spinner>
        <button mat-flat-button color="accent" class="reset-button" (click)="resetUpload()">{{ 'UPLOAD_DIALOG.RESET' | translate }}</button>
        <button mat-flat-button color="primary" [mat-dialog-close]>{{ 'UPLOAD_DIALOG.CLOSE' | translate }}</button>
    </div>
